import {Component, OnInit} from '@angular/core';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';

@Component({
  selector: 'app-booking-footer',
  templateUrl: './booking-footer.component.html',
  styleUrls: ['./booking-footer.component.scss'],
})
export class BookingFooterComponent implements OnInit {
  constructor(private bookingManager: BookingV2ManagerService) {}

  public ngOnInit(): void {}

  public closeBooking(): void {
    this.bookingManager.closeBooking();
  }
}
